<atn-ds-widget
  [title]="this.reportPluginSg().feature.selectors.name.asSignal()"
>
  <div class="atn-report-table">
    <div class="atn-report-table__content-wrapper">
      @if (columnsWidthSgs.length && rowsSg().length) {
        <div class="atn-report-table__content">
          <!-- TODO: Check if we need to create separate components for header, body and total sections -->
          <!-- Header -->
          @if (this.reportPluginSg().feature.selectors.headerRow.asSignal()) {
            <div
              class="atn-report-table__row"
              cdkDropList
              [cdkDropListLockAxis]="'x'"
              [cdkDropListSortingDisabled]="true"
            >
              @for (
                cell of this.reportPluginSg().feature.selectors.headerRow.asSignal()
                  ?.cells;
                track $index
              ) {
                <div
                  class="atn-report-table__cell"
                  [style.width.px]="columnsWidthSgs[$index]()"
                >
                  <atn-report-table-cell [cell]="cell"> </atn-report-table-cell>
                  <div
                    class="atn-report-table__cell-draggable"
                    cdkDrag
                    (cdkDragDropped)="dragDropHandler($event, $index)"
                  >
                    <div class="atn-report-table__cell-border"></div>
                  </div>
                </div>
              }
            </div>
          }

          <!-- Header end -->

          <!-- Body -->

          <!-- TODO: do we really need virtual scroll here? -->
          @let rows =
            this.reportPluginSg().feature.selectors.bodyRows.asSignal();
          @if (rows) {
            <cdk-virtual-scroll-viewport
              class="atn-report-table__body"
              [style.height]="bodyHeightSg()"
              itemSize="40"
              maxBufferPx="78"
              minBufferPx="39"
            >
              <div
                class="atn-report-table__row atn-report-table__row--body"
                *cdkVirtualFor="
                  let row of this.reportPluginSg().feature.selectors?.bodyRows?.asSignal()
                "
              >
                @for (cell of row.cells; track $index) {
                  <div
                    class="atn-report-table__cell"
                    [style.width.px]="columnsWidthSgs[$index]()"
                  >
                    <atn-report-table-cell [cell]="cell">
                    </atn-report-table-cell>
                  </div>
                }
              </div>
            </cdk-virtual-scroll-viewport>
          }
          <!-- Body end -->

          <!-- Total -->
          @let grandTotalRow =
            this.reportPluginSg().feature.selectors.grandTotalRow.asSignal();
          @if (grandTotalRow) {
            <div class="atn-report-table__row atn-report-table__row--total">
              @for (cell of grandTotalRow?.cells; track $index) {
                <div
                  class="atn-report-table__cell"
                  [style.width.px]="columnsWidthSgs[$index]()"
                >
                  <atn-report-table-cell [cell]="cell"> </atn-report-table-cell>
                </div>
              }
            </div>
          }
          <!-- Total end -->
        </div>
      } @else if (loadingSg()) {
        <atn-ds-loader type="table" />
      } @else {
        <div class="atn-report-table__empty-state">
          <atn-ds-empty-state
            action="Refresh"
            description="Uh oh! We couldn't find any content for this report"
            layout="h"
            title="Content not available"
            type="error"
            (action)="refreshButtonClickHandler()"
          >
          </atn-ds-empty-state>
        </div>
      }
    </div>
  </div>
</atn-ds-widget>
